module.exports = __webpack_public_path__ + "img/图片16.52cc480f.png";